import React from 'react';
import classNames from 'classnames';
import { bool, node, string, arrayOf, shape } from 'prop-types';
import Track from '../Base/Sensors/track';
import scrollIt from '../Base/Scroll';
import useWindowLocationHref from '../Hooks/useWindowLocation';

const AnchorNav = (props) => {
  const href = useWindowLocationHref();
  const classes = classNames({
    'anchor-nav': true,
    'anchor-nav--is-fixed': props.isWithinTrac,
    'anchor-nav--is-bottom': props.isTrackBottom,
    'anchor-nav--is-hidden': props.Links == null,
  });

  return (
    <div className={classes}>
      <div className="anchor-nav__inner">
        <nav className="anchor-nav__navigation">
          <h2 className="anchor-nav__heading">{props.anchorHeading}</h2>
          <ul className="anchor-nav__list">
            {props.Links &&
              props.Links.map((item, key) => {
                return (
                  <li
                    data-event-category={href || 'novalue'}
                    data-event-action={props.anchorHeading}
                    data-event-name="Ankarlänk"
                    key={key}
                  >
                    <a
                      data-event-include
                      className={classNames({
                        'anchor-nav__list__link': true,
                        'anchor-nav__list__link--is-selected':
                          props.currentActiveId === item.Id,
                      })}
                      onClick={() => {
                        scrollIt(
                          document.getElementById(`${item.Id}`),
                          300,
                          'easeOutQuad',
                          () => {
                            if (
                              typeof props.currentActiveMenuItem === 'function'
                            ) {
                              props.currentActiveMenuItem(item.Id);
                            }
                          }
                        );
                      }}
                      href={`#${item.Id}`}
                    >
                      {item.Name}
                    </a>
                  </li>
                );
              })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

const AnchorNavWithViewport = Track(AnchorNav);

const AnchorNavTrack = (props) => {
  return (
    <div className="anchor-nav-track">
      <AnchorNavWithViewport {...props} />
    </div>
  );
};

AnchorNavTrack.propTypes = {
  currentActiveId: string,
  anchorHeading: node,
  Links: arrayOf(
    shape({
      Id: string.isRequired,
      Name: node.isRequired,
    })
  ),
  /** From Track container */
  isWithinTrac: bool,
  /** From Track container */
  isTrackBottom: bool,
};

export default AnchorNavTrack;
